import { z } from "zod";

export const EXTRAS_CATEGORIES_FLAG_KEY = "extrasCategoriesActive";

const ACTIVE_VALUES = ["1", "true"];

const ExtrasCategoriesFlagSchema = z.string().optional();

export class ExtrasCategoriesFlagVO {
  private readonly active: boolean;

  private constructor(active: boolean) {
    this.active = active;
  }

  static fromConfigValue(value: string | undefined): ExtrasCategoriesFlagVO {
    const validated = ExtrasCategoriesFlagSchema.parse(value);
    return new ExtrasCategoriesFlagVO(
      validated !== undefined && ACTIVE_VALUES.includes(validated.trim().toLowerCase())
    );
  }

  static fromConfiguration(
    configuration: { [key: string]: string } | undefined
  ): ExtrasCategoriesFlagVO {
    return ExtrasCategoriesFlagVO.fromConfigValue(configuration?.[EXTRAS_CATEGORIES_FLAG_KEY]);
  }

  isActive(): boolean {
    return this.active;
  }
}
